import { useMediaQuery } from 'react-responsive';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import { TablePagination, Button } from '@mui/material';
import { DebouncedTextField } from '../DebouncedTextField';
import { Loading } from '../loading';
import MobileTable from './Mobile';
import DesktopTable from './Desktop';
import { useDataTable } from './useDataTable';
import ExportIcon from './ExportButton';
import * as XLSX from 'xlsx';

async function generateXLSX(data, name, getQuestions) {
  const questions = await getQuestions();
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(
    data.map((row) => {
      const newRow = {};
      Object.entries(row).forEach(([k, v]) => {
        const questionID = v?.QuestionID || v?.questionID;
        const question = questions.find(
          (question) => question.ID === questionID
        );
        if (question?.QuestionDescription) {
          newRow[question.QuestionDescription] = v?.Value || v?.value || v;
        } else {
          newRow[k] = v.split('T')[0];
        }
      });
      return newRow;
    })
  );
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Responses');
  XLSX.writeFile(workbook, name + '.xlsx');
}

export function DataTable({
  onRowClick,
  fetchRecords,
  columnsConfig,
  queryKey,
  exportRecords,
  getQuestions,
}) {
  const {
    table,
    handleChangePage,
    handleChangeRowsPerPage,
    clearFilters,
    globalFilter,
    setGlobalFilter,
    records,
  } = useDataTable({ queryKey, fetchRecords, columnsConfig });
  const isDesktop = useMediaQuery({
    query: '(min-width: 600px)',
  });

  if (records.isLoading || !records.data) {
    return <Loading />;
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <DebouncedTextField
          value={globalFilter ?? ''}
          onChange={(value) => setGlobalFilter(String(value))}
          placeholder="Search Full Documents"
        />
        <Button onClick={() => records.refetch()}>
          <ReplayIcon />
        </Button>
        <Button onClick={() => clearFilters()}>
          <DeleteOutlineIcon />
        </Button>
        {exportRecords ? (
          <Button
            title="Export"
            onClick={() =>
              generateXLSX(
                table.getRowModel().rows.map(({ original }) => original),
                queryKey,
                getQuestions
              )
            }
          >
            <ExportIcon />
          </Button>
        ) : null}
      </div>
      {isDesktop ? (
        <DesktopTable
          table={table}
          columnsConfig={columnsConfig}
          records={records.data}
          onRowClick={onRowClick}
        />
      ) : (
        <MobileTable
          table={table}
          records={records.data}
          columnsConfig={columnsConfig}
          onRowClick={onRowClick}
        />
      )}
      <TablePagination
        component="div"
        count={records.data.length}
        page={table.getState().pagination.pageIndex}
        onPageChange={handleChangePage}
        rowsPerPage={table.getState().pagination.pageSize}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}
